export default {
    companySetting: 'Company Setting',
    profile: 'Profile',
    branch: 'Branch',
    userManagement: 'User Management',
    department: 'Department',
    job: 'Job',
    companyHoliday: 'Company Holiday',
    leaveQuota: 'Leave Quota',
    blacklist: 'Blacklist'
}
